define('extensions/knockoutExtenders/trimmed',[
    'lib/knockout'
],function (ko) {
    "use strict";

    //Extends an observable (or computed observable) so that leading and trailing space is removed
    // obs.extend({trimmed: null});
    ko.extenders.trimmed = function(target) {
        var trimmed = ko.computed({
            read: target,
            write: function (newVal) {
                if(typeof newVal === "string") {
                    target(newVal.trim());
                } else {
                    target(newVal);
                }
            }
        });
        trimmed(target.peek()); //initialize
        return trimmed;
    };

});
